import React from "react"
import { useSelector, useDispatch } from "react-redux"
import { Row, Col } from "react-bootstrap"

import {
    EDIT,
    FIRST_DAY_OF_MONTH, TODAY,
    ONE_QUARTER, HALF_YEAR, ONE_YEAR,
    WEEKLY, BIWEEKLY, MONTHLY,
} from "const"
import {
    PRM_ACCOUNT_SETTINGS,
    StoreType,
    ChangeAccountSettings,
    updateAccountSettings,
} from "client/store"
import { hasAccess } from "client/utils"
import {
    PageForm,
    FormGroup,
    Label,
    CheckboxWrapper,
    RadioButton,
} from "client/components"


const DefaultAccountSettings = () => {
    const settings = useSelector((state: StoreType) => state.accountSettings.settings.okr)
    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const onChange = (value: ChangeAccountSettings) => {
        dispatch(updateAccountSettings("okr", value))
    }

    const {
        defaultSessionStartDate,
        defaultSessionDuration,
        defaultSessionCadence,
    } = settings

    const editAccess = hasAccess(PRM_ACCOUNT_SETTINGS, EDIT)

    return (
        <PageForm>
            <Row>
                <Col xs={12}>
                    <FormGroup>
                        <Label>{lang.defaultSessionStartDate}</Label>
                        <CheckboxWrapper displayColumn>
                            <RadioButton
                                readOnly={!editAccess}
                                checked={defaultSessionStartDate === FIRST_DAY_OF_MONTH}
                                onChange={() => onChange({ defaultSessionStartDate: FIRST_DAY_OF_MONTH })}
                                title={lang.firstDayOfMonth}
                            />
                            <RadioButton
                                readOnly={!editAccess}
                                checked={defaultSessionStartDate === TODAY}
                                onChange={() => onChange({ defaultSessionStartDate: TODAY })}
                                title={lang.today}
                            />
                        </CheckboxWrapper>
                    </FormGroup>
                    <FormGroup>
                        <Label>{lang.defaultSessionDuration}</Label>
                        <CheckboxWrapper displayColumn>
                            <RadioButton
                                readOnly={!editAccess}
                                checked={defaultSessionDuration === ONE_QUARTER}
                                onChange={() => onChange({ defaultSessionDuration: ONE_QUARTER })}
                                title={lang.oneQuarter}
                            />
                            <RadioButton
                                readOnly={!editAccess}
                                checked={defaultSessionDuration === HALF_YEAR}
                                onChange={() => onChange({ defaultSessionDuration: HALF_YEAR })}
                                title={lang.halfYear}
                            />
                            <RadioButton
                                readOnly={!editAccess}
                                checked={defaultSessionDuration === ONE_YEAR}
                                onChange={() => onChange({ defaultSessionDuration: ONE_YEAR })}
                                title={lang.oneYear}
                            />
                        </CheckboxWrapper>
                    </FormGroup>
                    <FormGroup>
                        <Label>{lang.defaultSessionCadence}</Label>
                        <CheckboxWrapper displayColumn>
                            <RadioButton
                                readOnly={!editAccess}
                                checked={defaultSessionCadence === WEEKLY}
                                onChange={() => onChange({ defaultSessionCadence: WEEKLY })}
                                title={lang.weekly}
                            />
                            <RadioButton
                                readOnly={!editAccess}
                                checked={defaultSessionCadence === BIWEEKLY}
                                onChange={() => onChange({ defaultSessionCadence: BIWEEKLY })}
                                title={lang.biweekly}
                            />
                            <RadioButton
                                readOnly={!editAccess}
                                checked={defaultSessionCadence === MONTHLY}
                                onChange={() => onChange({ defaultSessionCadence: MONTHLY })}
                                title={lang.monthly}
                            />
                        </CheckboxWrapper>
                    </FormGroup>
                </Col>
            </Row>
        </PageForm>
    )
}
export default DefaultAccountSettings
